var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEliminar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-eliminar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(-1370.000000, -444.000000)",
    fill: "#D1D1D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-copy",
    transform: "translate(651.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-eliminar",
    transform: "translate(719.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0742438,2.92581767 C13.1724148,-0.975272558 6.82694036,-0.975272558 2.92511138,2.92581767 C-0.975037127,6.8269079 -0.975037127,13.1741571 2.92511138,17.0752473 C4.87602587,19.0253821 7.43804713,20 10.0001075,20 C12.5621678,20 15.1233293,19.025343 17.0742438,17.0752473 C20.9752521,13.1741962 20.9752521,6.8269079 17.0742438,2.92581767 Z M14.1261822,12.9482261 C14.4521553,13.2742061 14.4521553,13.8011438 14.1261822,14.1271238 C13.963606,14.2897034 13.7501856,14.3714231 13.5367262,14.3714231 C13.3233058,14.3714231 13.1098464,14.2897034 12.9472702,14.1271238 L10.0000684,11.1790003 L7.05368728,14.126264 C6.89029037,14.2888436 6.67683094,14.3705633 6.46423128,14.3705633 C6.25081093,14.3705633 6.03735149,14.2888436 5.87477529,14.126264 C5.54880217,13.800284 5.54880217,13.2725256 5.87477529,12.9473663 L8.8211564,10.0001026 L5.87395459,7.05283887 C5.54798148,6.72685891 5.54798148,6.19910044 5.87395459,5.87394119 C6.199107,5.54796123 6.72685438,5.54796123 7.0528275,5.87394119 L10.0000293,8.82120492 L12.9472311,5.87394119 C13.2732042,5.54796123 13.8001309,5.54796123 14.126104,5.87394119 C14.4520771,6.19910044 14.4520771,6.72685891 14.126104,7.05283887 L11.1789022,10.0001026 L14.1261822,12.9482261 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEliminar);
export default __webpack_public_path__ + "static/media/ico-eliminar.e7aa9ea55dfb978a2f45cab66e450b12.svg";
export { ForwardRef as ReactComponent };